import {
  inject,
  Injectable,
} from '@angular/core';
import {Observable} from 'rxjs';
import {ApolloLink} from '@apollo/client';
import {UPDATE_LANGUAGE} from '../queries/lang.query.model';
import {ApiGraphqlService} from '../../core/api-graphql/api-graphql.service';
import {AnyObject} from '../../../../../models/object.model';

@Injectable({
  providedIn: 'root',
})
export class ApiLanguageService {

  private apiGraphqlService = inject(ApiGraphqlService);

  /**
   * Method API: Update language in application (used mutate)
   * @param language
   * @return: Observable
   */
  updateLanguageObservable(language: any): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.mutate(UPDATE_LANGUAGE, {language}, {useMultipart: true});
  }

}
